'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reducers = require('../utils/reducers');

var getInitialState = function getInitialState() {
  return {
    listSubDirs: (0, _reducers.getFetchSubState)('initial'),
    listDirs: (0, _reducers.getFetchSubState)('initial'),
    createSubDir: (0, _reducers.getFetchSubState)('initial'),
    createDir: (0, _reducers.getFetchSubState)('initial'),
    removeDir: (0, _reducers.getFetchSubState)('initial'),
    editDir: (0, _reducers.getFetchSubState)('initial')
  };
};
var initialState = getInitialState();

var actionsMap = _extends({
  resetFetchSubState: function resetFetchSubState(state /*, action*/) {
    return _extends({}, state, getInitialState());
  }
}, (0, _reducers.fetchReducer)('listSubDirs', { resultName: true }), (0, _reducers.fetchReducer)('listDirs', { resultName: true }), (0, _reducers.fetchReducer)('createSubDir', { resultName: true }), (0, _reducers.fetchReducer)('createDir', { resultName: true }), (0, _reducers.fetchReducer)('removeDir', { resultName: true }), (0, _reducers.fetchReducer)('editDir', { resultName: true }));

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var reduceFn = actionsMap[action.type];
  if (!reduceFn) return state;
  return reduceFn(state, action);
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/reducers/dir.js
// module id = 516
// module chunks = 1